import { useEffect, useState } from "react";
import { adminService } from "../../../../services/admin-service";
import { AdminPageHeader, AdminPanel, EmptyState, formatDate } from "./admin-ui";

function AdminAuditLogsPage() {
    const [logs, setLogs] = useState([]);
    const [message, setMessage] = useState("");

    useEffect(() => {
        adminService.auditLogs().then((data) => setLogs(data.logs || [])).catch((error) => setMessage(error.message));
    }, []);

    return (
        <>
            <AdminPageHeader title="Audit Logs" subtitle="Admin and system action history" />
            {message && <div className="alert alert-info">{message}</div>}
            <AdminPanel title="Recent Actions" icon="fa fa-history">
                <div className="table-responsive">
                    <table className="table table-bordered">
                        <thead><tr><th>Action</th><th>Entity</th><th>Admin</th><th>Metadata</th><th>Date</th></tr></thead>
                        <tbody>
                            {logs.length === 0 ? (
                                <tr><td colSpan="5"><EmptyState text="No audit logs found." /></td></tr>
                            ) : logs.map((log) => (
                                <tr key={log.id}>
                                    <td>{log.action}</td>
                                    <td>{log.entity_type}<div className="text-muted">{log.entity_id}</div></td>
                                    <td>{log.actor_name || "System"}</td>
                                    <td><small>{log.metadata}</small></td>
                                    <td>{formatDate(log.created_at)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </AdminPanel>
        </>
    );
}

export default AdminAuditLogsPage;
